import type {
    AccountAddressesErrorResponse,
    AccountAddressesSuccessResponse,
    AddAddressRequest,
    RemoveAddressResponse,
} from '@libs/common-next';
import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

export async function getAddresses() {
    const url = CWEA_ENDPOINTS.addresses.getAddresses;
    return await cweaClient.get<AccountAddressesSuccessResponse[]>(url);
}

export async function addAddress(body: AddAddressRequest) {
    const url = CWEA_ENDPOINTS.addresses.addAddress;

    return await cweaClient.post<
        AccountAddressesSuccessResponse | AccountAddressesErrorResponse | null,
        AddAddressRequest
    >(url, {
        body,
        additionalSuccessCodes: [409, 400],
    });
}

export async function updateAddress(
    addressId: number,
    body: AddAddressRequest
) {
    const url = CWEA_ENDPOINTS.addresses.updateAddress(addressId);

    return await cweaClient.put<
        AccountAddressesSuccessResponse | AccountAddressesErrorResponse | null,
        AddAddressRequest
    >(url, {
        body,
    });
}

export async function removeAddress(addressId: number) {
    const url = CWEA_ENDPOINTS.addresses.removeAddress(addressId);

    return await cweaClient.delete<RemoveAddressResponse | null>(url, {
        additionalSuccessCodes: [400, 401, 404, 500],
    });
}
